import { useState } from "react";
import Link from "next/link";
import { HeaderItem } from "@/types/menu";
import { Icon } from "@iconify/react";

interface MobileLinkProps {
  item: HeaderItem;
  depthLevel?: number;
  closeMenu: () => void;
}

const MobileHeaderLink: React.FC<MobileLinkProps> = ({
  item,
  depthLevel = 0,
  closeMenu,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Indentation logic
  const paddingLeft = depthLevel * 16 + 16;

  // Basic styling
  const commonClasses = `flex items-center w-full py-3 text-midnight_text dark:text-white border-b border-gray-100 dark:border-white/5 transition-colors hover:text-primary`;

  // Helper
  const isLink = item.href && item.href !== "#";

  if (item.submenu) {
    return (
      <div className="w-full">
        {/* ROW: Contains Link (Left) and Toggle (Right) if navigable */}
        <div
          className={`flex items-center justify-between w-full border-b border-gray-100 dark:border-white/5 pr-4`}
        >
          {isLink ? (
            // 1. NAVIGABLE PARENT: Text is a Link
            <Link
              href={item.href}
              onClick={closeMenu}
              className="flex-1 py-3 hover:text-primary transition-colors text-midnight_text dark:text-white"
              style={{ paddingLeft: `${paddingLeft}px` }}
            >
              {item.label}
            </Link>
          ) : (
            // 2. NON-NAVIGABLE PARENT: Text triggers toggle
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="flex-1 py-3 text-left hover:text-primary transition-colors text-midnight_text dark:text-white"
              style={{ paddingLeft: `${paddingLeft}px` }}
            >
              {item.label}
            </button>
          )}

          {/* TOGGLE BUTTON (Chevron) */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="p-2 border-l border-gray-100 dark:border-white/5 ml-2 hover:bg-gray-50 dark:hover:bg-white/10 rounded-md"
            aria-label="Toggle submenu"
          >
            <Icon
              icon="ion:chevron-down"
              className={`text-lg transition-transform duration-300 ${
                isOpen ? "rotate-180 text-primary" : ""
              }`}
            />
          </button>
        </div>

        {/* ACCORDION BODY */}
        <div
          className={`grid transition-all duration-300 ease-in-out overflow-hidden ${
            isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
          }`}
        >
          <div className="overflow-hidden bg-gray-50/50 dark:bg-black/20">
            {item.submenu.map((subItem, index) => (
              <MobileHeaderLink
                key={index}
                item={subItem}
                depthLevel={depthLevel + 1}
                closeMenu={closeMenu}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  // STANDARD LINK (No Submenu)
  return (
    <Link
      href={item.href}
      onClick={closeMenu}
      className={`${commonClasses} pr-4 justify-between`}
      style={{ paddingLeft: `${paddingLeft}px` }}
    >
      {item.label}
    </Link>
  );
};

export default MobileHeaderLink;
